import Link from "components/Profile/AdminLinks/Link";
import PropTypes from "prop-types";
import React from "react";
import adminActionType from "components/Profile/AdminLinks/adminActionType";

import styles from "./styles.scss";

export default function AdminLinks({ adminActions }) {
  const links = adminActions.map(action => <Link key={action.path} adminAction={action} />);

  return <div className={styles.container}>{links}</div>;
}

AdminLinks.propTypes = {
  adminActions: PropTypes.arrayOf(adminActionType).isRequired,
};
